export default __webpack_public_path__ + "static/media/haley stevens.6160a8ae.jpg";